import { useRouter } from "next/router";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import gutter from "src/functions/gutter";

function PricesPaid() {
  const { locale: lang } = useRouter();

  switch (lang) {
    case `cs`:
      return (
        <>
          <Heading type="h2" variant="primary" title={`Prodej po kusech`} />
          <Paragraph size="md" width={`semibold`}>
            Plaťte pouze za to, co skutečně používáte
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Chcete si koupit prémiový obsah, vyzkoušet naši platformu nebo
            cvičíte jen občas? Vyberte si kurz nebo lekci, která vám vyhovuje a
            plaťte pouze za to, co si odcvičíte. Ceny obsahu si určují lektoři
            sami.
          </Paragraph>
          <br />
        </>
      );
    case `sk`:
      return (
        <>
          <Heading type="h2" variant="primary" title={`Predaj po kusoch`} />
          <Paragraph size="md" width={`semibold`}>
            Plaťte iba za to, čo skutočne používate
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Chcete si kúpiť prémiový obsah, vyskúšať našu platformu alebo
            cvičíte iba občas? Vyberte si kurz alebo lekciu, ktorá vám vyhovuje
            a plaťte iba za to, čo si odcvičíte. Ceny obsahu si určujú lektori
            sami.
          </Paragraph>
          <br />
        </>
      );
    default:
      // also EN
      return (
        <>
          <Heading type="h2" variant="primary" title={`Sale in pieces`} />
          <Paragraph size="md" width={`semibold`}>
            Only pay for what you really use
          </Paragraph>
          <Paragraph
            size="xn"
            width={`regular`}
            style={gutter(`margin`, `bottom`, `0`)}
          >
            Do you want to buy premium content, try our platform or practice
            only occasionally? Choose a serie or class that suits you and pay
            only for what you practice. The prices of the content are determined
            by the instructors themselves.
          </Paragraph>
          <br />
        </>
      );
  }
}

export default PricesPaid;
